/**
 * @typedef {{
 *    products: string,
 *    exhibitors: string,
 *    producers: string,
 *    productLists: string,
 *    home: string,
 * }} LinkContext
 */
/**
 * Returns the functions to create a link to a particular entity.
 * This is in CommonJS because it is also used from gatsby-node.
 * @param {LinkContext} context
 * @returns
 */
module.exports = function getLink(context) {
  return {
    /**
     * Returns the path to the exhibitors list.
     * @returns
     */
    exhibitors: () => `/${context.exhibitors}`.replace(/\/\/+/g, '/'),

    /**
     * Generates a link to an exhibitor.
     * @param {{ exhibitorId: string }} exhibitor
     * @returns
     */
    exhibitor: (exhibitor) => {
      if (!exhibitor) return null;
      return `/${context.exhibitors}/${exhibitor.exhibitorId}`.replace(
        /\/\/+/g,
        '/'
      );
    },

    /**
     * Generates a link to the products list.
     * @returns
     */
    products: () => `/${context.products}`.replace(/\/\/+/g, '/'),

    /**
     * Generates a link to a product.
     * If a producerId is provided, it links to the producer's product route, otherwise it uses the exhibitor route (this behavior will probably change in the future).
     * @param {{ productId: string, exhibitorId?: string, producerId?: string }} product
     * @returns
     */
    product: (product) => {
      const { productId, exhibitorId, producerId } = product || {};
      if (!product) return undefined;
      if (producerId) {
        return `/${context.producers}/${producerId}/${context.products}/${productId}`.replace(
          /\/\/+/g,
          '/'
        );
      }
      if (exhibitorId) {
        return `/${context.exhibitors}/${exhibitorId}/${context.products}/${productId}`.replace(
          /\/\/+/g,
          '/'
        );
      }
      return `/${context.products}/${productId}`.replace(/\/\/+/g, '/');
    },

    /**
     * Generates a link to a producer.
     * @param {{ producerId: string }} producer
     * @returns
     */
    producer: (producer) => {
      if (!producer) return undefined;
      return `/${context.producers}/${producer.producerId}`.replace(
        /\/\/+/g,
        '/'
      );
    },

    /**
     * Generates a link to the producers list.
     * @returns
     */
    producers: () => `/${context.producers}`.replace(/\/\/+/g, '/'),

    /**
     * Generates a link to a product list.
     * @param {{ productListId: string }} productList
     * @returns
     */
    productList: (list) => {
      if (!list) return undefined;
      return `/${context.productLists}/${list.productListId}`.replace(
        /\/\/+/g,
        '/'
      );
    },

    /**
     * Generates a link to the home page.
     * @returns
     */
    home: () => `/${context.home}`.replace(/\/\/+/g, '/'),
  };
};
